var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner",style:({ backgroundImage: _vm.bannerBgImage })})
}
var staticRenderFns = []

export { render, staticRenderFns }